// extracted by mini-css-extract-plugin
export default {"pannel":"styles_pannel__gdyD7","pannelData":"styles_pannelData__iGCxQ","dataItem":"styles_dataItem__D4mbi","icon":"styles_icon__mlStV"};